﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { Tabla, TablaComponent } from '../../tabla';
import { ActivatedRoute, Router } from '@angular/router';

@Component({ templateUrl: 'resultado.component.html' })
export class RootResultadoComponent implements OnInit {

    data: any;

    categoriaDeporte: any;

    categoriaDeporteObject: any;

    anio: any;

    sexo: any;

    sexoObject: any;

    indexSexo = 0;

    indexCategoriaDeporte = 0;

    data2: any;

    resumenMixto: boolean = false;

    postaPorCategoria: boolean = false;

    interhouses: boolean = false;

    tabla: Tabla = {
        titulo: 'Posiciones',
        hideHeader: true,
        hideFilter: true,
        externalData: true,
        endPoint: '/rest-api/root/resultado',
        editable: false,
        nuevo: false,
        columnas: [
            {
                name: 'id',
                prop: 'id',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 20,
                hidden: true
            },
            {
                name: 'Puesto',
                prop: 'puesto',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 20
            },
            {
                name: 'Sexo',
                prop: 'alumno.sexo',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                sexo: true,
                width: 50
            },
            {
                name: 'Alumno',
                prop: 'alumno',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 200
            },
            {
                name: 'Casa',
                prop: 'alumno.casa',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                casa: true,
                width: 100
            },
            {
                name: 'Valor',
                prop: 'valor',
                editable: true,
                resizeable: true,
                sortable: true,
                icon: true,
                width: 100,
                pattern: true
            }
        ]
    };

    @ViewChild(TablaComponent) tablaComponent: TablaComponent;

    constructor(private restService: RestService, private router: Router, private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {
            this.interhouses =  params['interhouses'] === 'true';
            if (params['sexo']) {
                this.sexo = JSON.parse(params['sexo']);
                this.categoriaDeporte = JSON.parse(params['categoria']);
            }
            if (params['anio']) {
                this.anio = JSON.parse(params['anio']);
            } else {
                this.anio = this.currentYear();
            }
            this.restService.getParam('resumen.mixto').subscribe(data => {
                this.resumenMixto = data.valor.toUpperCase() === 'TRUE';
            });
            this.restService.getParam('posta.por.categoria').subscribe(data => {
                this.postaPorCategoria = data.valor.toUpperCase() === 'TRUE';
                this.loadAll();
            })
        });
    }

    ngOnInit() {
    }

    loadAll() {
        this.restService.getAll('/rest-api/root/resultado/cargar?interhouses='+ this.interhouses).subscribe(data => {
            this.data2 = undefined;
            this.data = data;
            this.searchPlanilla();
        });
    }

    searchPlanilla() {

        this.categoriaDeporte = this.data.categoriaDeporte[this.indexCategoriaDeporte].id;
        this.sexo = this.data.sexo[this.indexSexo].id;
        if (this.categoriaDeporte && this.sexo) {
            this.categoriaDeporteObject = undefined;
            this.sexoObject = undefined;
            var sexoURL = '';
            if (!this.resumenMixto) {
                sexoURL = 'sexo=' + this.sexo.toString() + '&';
            }
            this.restService.getAll('/rest-api/root/resultado/?' + sexoURL +
            'categoriaDeporte=' + this.categoriaDeporte.toString() +
            '&anio=' + this.anio + '&primeros=true').subscribe(data => {
                this.data2 = data;
                if (this.tablaComponent) {
                        this.tablaComponent.categoriaDeporte = this.data.categoriaDeporte[this.indexCategoriaDeporte];
                        this.tablaComponent.allData = this.getDatos();
                        this.tablaComponent.rows = this.getDatos();
                    }
                });
        }
    }

    getDatos(): any {
        return {
            'data': this.data2.data,
            'paramAnio': this.currentYear(),
            'paramCategoriaDeporte': this.getCategoriaDeporte(),
            'paramSexo': this.getSexo()
        };
    }

    getCategoriaDeporte(): any {
        if (!this.categoriaDeporteObject) {
            this.data.categoriaDeporte.forEach(cat => {
                if (this.categoriaDeporte.toString() === cat.id.toString()) {
                    this.categoriaDeporteObject = cat;
                }
            });
        }
        return this.categoriaDeporteObject;
    }

    getSexo(): any {
        if (!this.sexoObject) {
            this.data.sexo.forEach(cat => {
                if (this.sexo.toString() === cat.id.toString()) {
                    this.sexoObject = cat;
                }
            });
        }
        return this.sexoObject;
    }


    currentYear(): number {
        return (new Date()).getFullYear();
    }

    getTitulo(): string {
        var sexo = '';
        if (!this.resumenMixto) {
            sexo = ' - ' + this.getSexo().nombre;
        }
        return this.getCategoriaDeporte().deporte.nombre + ' - ' + this.getCategoriaDeporte().categoria.nombre
            + sexo;
    }

    anterior() {
        if (!this.resumenMixto) {
            if (this.getCategoriaDeporte().deporte.girls && this.getCategoriaDeporte().deporte.boys) {
                if (this.indexSexo === 1) {
                    this.indexSexo = 0;
                } else {
                    this.indexCategoriaDeporte = this.indexCategoriaDeporte - 1;
                    this.indexSexo = this.data.categoriaDeporte[this.indexCategoriaDeporte].deporte.girls?1:0;
                }
            } else if (this.getCategoriaDeporte().deporte.girls) {
                   this.indexCategoriaDeporte = this.indexCategoriaDeporte - 1;
                   this.indexSexo = this.data.categoriaDeporte[this.indexCategoriaDeporte].deporte.girls?1:0;
            } else if (this.getCategoriaDeporte().deporte.boys) {
                   this.indexCategoriaDeporte = this.indexCategoriaDeporte - 1;
                   this.indexSexo = this.data.categoriaDeporte[this.indexCategoriaDeporte].deporte.girls?1:0;
            }
        } else {
            this.indexSexo = 0;
            this.indexCategoriaDeporte = this.indexCategoriaDeporte - 1;
        }
        this.searchPlanilla();

    }

    siguiente() {

        if (!this.resumenMixto) {
            if (this.getCategoriaDeporte().deporte.girls && this.getCategoriaDeporte().deporte.boys) {
                if (this.indexSexo === 0) {
                  this.indexSexo = 1;
                } else {
                  this.indexCategoriaDeporte = this.indexCategoriaDeporte + 1;
                  this.indexSexo = this.data.categoriaDeporte[this.indexCategoriaDeporte].deporte.boys?0:1;
                }
            } else {
               this.indexCategoriaDeporte = this.indexCategoriaDeporte + 1;
               this.indexSexo = this.data.categoriaDeporte[this.indexCategoriaDeporte].deporte.boys?0:1;
            }
        } else {
            this.indexSexo = 0;
            this.indexCategoriaDeporte = this.indexCategoriaDeporte + 1;
        }
        this.searchPlanilla();
    }

    puntos() {
        this.router.navigate(['/user/puntos'], { queryParams: { anio: this.anio } });
    }


}
